const NEWSLETTER_SIGN_UP = 'newsletterSignUp';
const EMAIL_OPT_FLAG_YES = 'Y';
const EMAIL_OPT_FLAG_NO = 'N';
const NOT_PROVIDED = 'not provided';
const CHECKBOX_NAME = 'checkbox';

export { NEWSLETTER_SIGN_UP, EMAIL_OPT_FLAG_YES, EMAIL_OPT_FLAG_NO, CHECKBOX_NAME, NOT_PROVIDED };
